import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import { route } from "preact-router";
import { Alert, Badge, Box, Button, Grid, IconButton, Paper, Stack, Tabs, Tab, Tooltip, Typography } from "@mui/material";

import { AppContext } from "../../AppContext";
import { makeStyles } from "@mui/styles";

import BackButton from "../Common/BackButton";
import UserDetails1 from "../Common/UserDetails1";
import UserDetails2v2 from "../Common/UserDetails2v2";
import SellerDetails from "../Common/SellerDetails";
import BuyerDetails from "../Common/BuyerDetails";

import { resendconfmail2 } from "../Common/functions";

//import { resendconfmail } from "../Common/functions";



function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`scrollable-auto-tabpanel-${index}`}
			aria-labelledby={`scrollable-auto-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

export default function DealUser({ uid, from }) {
	console.log("DeaalUser", from)
	//const [app, setApp] = useContext(AppContext);
	const app = useContext(AppContext);
	const [state, setState] = useState({ changes: false, uid: uid });
	const [updatedData, setUpdatedData] = useState({ uid: uid });

	const [tab, setTab] = useState(0);
	const handleChangeTab = (event, newValue) => {
		setTab(newValue);
	};
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/odu/" + uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							...res.pld,
							phone1_init: res.pld.phone1,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	useEffect(() => {

		const visible_statut = (state.marital_status_id == "1" ||
			(state.marital_status_id == "2" && (state.union == "N" || (state.union == "O" && state.has_union_with_id !== null))));
		var actualTab = 0;
		console.log(visible_statut, state.marital_status_id, state.union)
		if (!visible_statut) {
			actualTab = 2
		}
		if (state.visible_statut !== visible_statut) {
			setState({ ...state, visible_statut: visible_statut })
		}
		setTab(actualTab);
		if (state.popup_is_onboarded === 1) {
			app.refPopUp.current.handleChangeState(
				{ opened: true, type: "031", params: { deal_uid: state.deal_uid, uid: uid, type: state.tp } }
			)
		}
	}, [state]);
	const useStyles = makeStyles((theme) => ({
		root: {
			display: "flex",
			flexWrap: "wrap",
		},
		textField: {
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			width: "25ch",
		},
		formControl: {
			margin: theme.spacing(1),
			marginLeft: 0,
			minWidth: 120,
			width: "100%",
		},
	}));

	function a11yProps(index) {
		return {
			id: `scrollable-auto-tab-${index}`,
			"aria-controls": `scrollable-auto-tabpanel-${index}`,
		};
	}
	const handleChange = (event) => {
		setUpdatedData({
			...updatedData,
			changes: true,
			[event.target.name]: event.target.value,
		});
	};
	const classes = useStyles();

	const handleChangeCheckbox = (event) => {
		setUpdatedData({
			...updatedData,
			changes: true,
			[event.target.name]: event.target.checked
		});
	};
	const handleSubmit = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(updatedData),
		};
		fetch("/api/fc5942a7e5c54575b35cb2dde461d9c6", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						// if (tab === 2) {
						// 	if (state.type == "VN") {
						// 		window.location.href = "/11d1355181ac4376a09980601b420617/" + state.deal_uid;
						// 	}
						// } else {
						window.location.reload();
						// }
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	const dutype = (id) => {
		if (id === 2) return "vendeur";
		if (id === 3) return "prospect";
		if (id === 4) return "acquéreur";
	};
	const dutype1 = (id) => {
		if (id === 2) return "VN";
		if (id === 3) return "PR";
		if (id === 4) return "AC";

	};
	if (state.email === undefined) return;
	return (
		<div style="">
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper style="padding: 10px">
						<Box display="flex" justifyContent="space-between" alignItems="center">

							<Box p={1}>
								<BackButton tooltip={"Revenir en arrière"} from={from} />
							</Box>
							<Box p={1}>
								<Typography variant="h5">Informations {dutype(state.tp)}</Typography>
							</Box>

							<Box p={1}>
								{!state.mail_ok && (
									<Grid item key={1}>
										<Button
											variant="outlined"
											style="min-width: 300px;"
											onClick={() => {
												resendconfmail2(app, uid);
											}}
										>
											Renvoyer un mail de confirmation
										</Button>
									</Grid>
								)}
								{false && state.is_deal_proxy && <Button
									variant="contained"
									onClick={() => {
										state.has_location_and_type
											? state.complete
												? app.refPopUp.current.handleChangeState(
													{
														opened: true,
														type: "002",
														params: {
															yes_action: () => {

																app.refPopUp.current.handleChangeState(
																	{
																		opened: true,
																		type: "008",
																		users: state.siblings,
																		uid: uid,
																		src: "du",
																		side: dutype1(state.tp)
																	}
																)

															},
															title: "Attention",
															body: (
																<div>
																	<Typography variant="body1" gutterBottom>
																		Le mandat de vente a déjà été émis, une modification apportée à un ou plusieurs
																		{dutype(state.tp)}s va entraîner son annulation et un nouveau processus de signature.
																	</Typography>
																	<Typography variant="h5" gutterBottom>
																		Voulez vous vraiment rajouter un {dutype(state.tp)}?
																	</Typography>
																</div>
															)
														}
													}
												) :
												app.refPopUp.current.handleChangeState(
													{
														opened: true,
														type: "008",
														users: state.siblings,
														uid: uid,
														src: "du"
													}
												)
											: app.refPopUp.current.handleChangeState(
												{
													opened: true,
													type: "001",
													params: {
														title: "Attention",
														body: (
															<div>
																<Typography variant="body1" gutterBottom>
																	Vous ne pouvez pas rajouter un {dutype(state.tp)} sans avoir d'abord spécifié une adresse et un
																	type de bien
																</Typography>
																<Button>Gérer le bien du dossier de vente</Button>
															</div>
														),
													}
												}
											)

									}}
								>
									Ajouter un {dutype(state.tp)}
								</Button>}
							</Box>
						</Box>
					</Paper>
				</Grid>
				<Grid item xs={12} md={3}>
					<Paper style="padding: 10px; height: 100%;">
						<Stack spacing={2} >
							<Typography variant="h5">Vous devez indiquer ici votre statut matrimonial.</Typography>
							{/* <Typography variant="body1">Cliquez sur le bouton ci-dessous :)</Typography> */}
							{/* <Button variant="outlined" onClick={() => { window.location.href = "/user" }}>Mon profil</Button> */}
						</Stack>
					</Paper>
				</Grid>
				<Grid item xs={12} md={9}>
					{state.iob && <Paper style={{ marginBottom: "10px" }}>
						<Alert severity="success" >
							Vous avez rempli toutes les informations
						</Alert>
					</Paper>}
					<Paper square>
						<Tabs value={tab} indicatorColor="primary" textColor="primary" onChange={handleChangeTab} aria-label="user tabs">
							<Tab label="Général" {...a11yProps(0)} />
							<Tab label="Adresse" {...a11yProps(1)} />
							<Tab label={<Badge color="primary" variant="dot" invisible={state.visible_statut}>
								Mon statut
							</Badge>
							} {...a11yProps(2)} />

						</Tabs>
						<TabPanel value={tab} index={0}>
							<UserDetails1 state={{ ...state, ...updatedData }} handleChange={handleChange} mode="DU" />
						</TabPanel>
						<TabPanel value={tab} index={1}>
							<UserDetails2v2 state={{ ...state, ...updatedData }} handleChange={handleChange} noUpdate={true} />
						</TabPanel>
						<TabPanel value={tab} index={2}>
							{state.type === "VN" ? (
								<SellerDetails
									state={{ ...state, ...updatedData }}
									handleChange={handleChange}
									handleChangeCheckbox={handleChangeCheckbox}
									du_uid={uid}
								/>
							) : (
								<BuyerDetails
									state={{ ...state, ...updatedData }}
									handleChange={handleChange}
									handleChangeCheckbox={handleChangeCheckbox}
								/>
							)}
						</TabPanel>

						{tab < 3 && (
							<Box display="flex" justifyContent="space-between" alignItems="center">
								<Box>
									<Button
										outlined
										disabled={!state.changes}
										onClick={() => {

											window.reload();
										}}
									>
										Annuler les changements
									</Button>
								</Box>
								<Box p={1}>
									<Button variant="contained" disabled={!updatedData.changes} onClick={handleSubmit}>
										Valider
									</Button>
								</Box>
							</Box>
						)}
					</Paper>
				</Grid>

			</Grid>
		</div>
	);
}
